import { render } from "./TakeDelivery.vue?vue&type=template&id=e15777da&scoped=true"
import script from "./TakeDelivery.vue?vue&type=script&lang=js"
export * from "./TakeDelivery.vue?vue&type=script&lang=js"

import "./TakeDelivery.vue?vue&type=style&index=0&id=e15777da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e15777da"

export default script